// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"017513d8","703":"3f9b58ea","787":"27da82a2"}[chunkId] + ".chunk.js";
};